import React from 'react'
import { useForm } from 'react-hook-form'
import { toast } from 'react-toastify'

import { ModalBase, Text, Column, Row, Button } from '../../../index'

import { deleteLeadDocument } from '../../../../../services/v3'

const ModalDeleteDoc = ({ open, handleClose, fetchInfos }) => {
  const {
    handleSubmit,
    formState: { isSubmitting }
  } = useForm()

  const onSubmit = async () => {
    try {
      await deleteLeadDocument(open.id).then(() => {
        fetchInfos()
        toast.success('Documento deletado com sucesso.')
      })
    } catch {
      toast.error('Erro ao deletar documento')
    } finally {
      handleClose()
    }
  }

  return (
    <ModalBase open={!!open ? true : false} onClose={handleClose} height='100%' width='100%' title='Documento'>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Column justifyContent='space-around' style={{ gap: '20px' }}>
          <Text variant='h4'>Você tem certeza que deseja deletar este documento?</Text>

          <Row>
            <Button height={40} width={227} onClick={handleClose} mr={3} variant='outlined'>
              Cancelar
            </Button>
            <Button height={40} width={227} type='submit' loader={isSubmitting}>
              Sim
            </Button>
          </Row>
        </Column>
      </form>
    </ModalBase>
  )
}

export default ModalDeleteDoc
